<template>
  <FullCalendar ref="fullcalendar" :options="state.calendarOptions" />
</template>
<script setup>
// solves problem with Vite
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { reactive, ref } from "@vue/reactivity";
import { onMounted, defineEmits } from "@vue/runtime-core";

const emit = defineEmits(["selected", "datesChanged", "eventSelected"]);

const state = reactive({
  calendarOptions: {
    plugins: [dayGridPlugin, interactionPlugin],
    initialView: "dayGridMonth",
    nextDayThreshold: "06:00:00",
    weekends: false,
    height: "auto",
    selectable: true,
    eventDisplay: "block",
    select(e) {
      emit("selected", {
        start: new Date(e.start),
        end: new Date(e.end),
      });
    },
    eventClick(e) {
      emit("eventSelected", e);
    },
    views: {
      dayGrid: {
        displayEventTime: false,
      },
    },
    datesSet(e) {
      emit("datesChanged", e);
    },
    customButtons: {
      toggleWeekends: {
        text: "Toggle Weekends",
        click: function () {
          let api = getApi();
          api.setOption("weekends", !api.getOption("weekends"));
        },
      },
    },
    headerToolbar: {
    center: 'toggleWeekends'
  }
  },
});

const fullcalendar = ref(null);

const getApi = () => fullcalendar.value.getApi();

const addEvents = (events) => {
  let count = 0;
  const api = fullcalendar.value.getApi();
  events.forEach((event) => {
    let foundEvent = api.getEventById(event.id);
    if (foundEvent) {
      foundEvent.setStart(event.start);
      foundEvent.setEnd(event.end);
      foundEvent.setProp("title", event.title);
      foundEvent.setProp("borderColor", event.borderColor);
    } else {
      count++;
      let x = api.addEvent(event);
    }
  });
};

defineExpose({
  fullcalendar,
  getApi,
  addEvents,
});
</script>
